import { render, staticRenderFns } from "./DeleteAccountStepOne.vue?vue&type=template&id=d882830c&scoped=true"
import script from "./DeleteAccountStepOne.vue?vue&type=script&lang=js"
export * from "./DeleteAccountStepOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d882830c",
  null
  
)

export default component.exports